module.exports = __webpack_public_path__ + "img/us-selected.aa2e1251.svg";